import React, { useState } from "react";

import {
  Tooltip,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

// import { useMutation, useQuery } from "@apollo/client"
//icons
import { CiCircleList } from "react-icons/ci";
import { FaRegEye } from "react-icons/fa";
import { BiMinusCircle } from "react-icons/bi";
import { RiFilePaper2Fill } from "react-icons/ri";
import { TbEdit } from "react-icons/tb";

import ViewAdjustOut from "./ViewAdjustOut";
//src
import "../../../Style/actionstyle.scss";
import UpdateAdjustOut from "./UpdateAdjustOut";

export default function AdjustOutAction({ editData , setRefetch }) {

  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseOpenView = () => setOpenView(false);


  // 
  const [openUpdate, setOpenUpdate] = useState(false);
  const handleOpenUpdate = () => setOpenUpdate(true);
  const handleCloseOpenUpdate = () => setOpenUpdate(false);

  return (
    <div>
      <Tooltip title="ពិនិត្យការផ្ទេរចេញ" placement="top">
        <IconButton onClick={handleOpenView}>
          <Box className="view-container">
            <RiFilePaper2Fill className="view-icon" />
          </Box>
        </IconButton>
      </Tooltip>


      <Tooltip title="កែប្រែការផ្ទេរចូល" placement="top">
        <IconButton onClick={handleOpenUpdate}>
          <Box className="update-container">
            <TbEdit className="view-icon" />
          </Box>
        </IconButton>
      </Tooltip>

    {
      openView && 
      <ViewAdjustOut
        open={openView}
        handleClose={handleCloseOpenView}
        editData={editData}
      />
    }

    {
      openUpdate && 
      <UpdateAdjustOut
        open={openUpdate}
        handleClose={handleCloseOpenUpdate}
        editData={editData}
        setRefetch={setRefetch}
      />
    }      

    </div>
  );
}
